export enum RegistrationSteps {
    Info = 'info',
    Email = 'email',
    Pin = 'pin',
    ContactInfo = 'contactinfo',
    StudentInfo = 'studentinfo',
    EmergencyInfo = 'emergencyinfo',
    TermsAndConditions = 'terms',
    Payment = 'payment',
    AddPin = 'addpin',
    Sucess = 'success'
}